$('.widget_nav_menu .menu-item-has-children a').on('click', function(event) {
    if(!$(this).parent().hasClass('collapsed')) {
        event.preventDefault();

        $(this).parent().addClass('collapsed');
    }
});